import React from "react";

/**
 * Navegacao entre as secoes da tela de agendamento.
 *
 * Substitui o botao unico cujo rotulo mudava a cada tela ("Ver agenda",
 * "Ver meus agendamentos", "Voltar para agenda"): com as duas secoes sempre
 * visiveis, o usuario ve onde esta sem precisar ler o rotulo para descobrir
 * para onde vai.
 *
 * @param {{label: string, value: any, icon?: string}[]} tabs
 * @param {any} active                      valor da aba ativa
 * @param {(value: any) => void} onSelect
 * @param {string} panelId                  id do conteudo que as abas controlam
 */
export default function SectionTabs({ tabs, active, onSelect, panelId }) {
  return (
    <div
      className={"sched-tabs" + (tabs.length === 1 ? " sched-tabs-single" : "")}
      role="tablist"
      aria-label="Seções do agendamento"
    >
      {tabs.map(({ label, value, icon }) => {
        const isActive = value === active;

        return (
          <button
            key={label}
            type="button"
            role="tab"
            id={`sched-tab-${value}`}
            aria-selected={isActive}
            aria-controls={panelId}
            className={"sched-tab" + (isActive ? " sched-tab-active" : "")}
            onClick={() => onSelect(value)}
          >
            {icon && <i className={`${icon} sched-tab-icon`} aria-hidden="true" />}
            {label}
          </button>
        );
      })}
    </div>
  );
}
